import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import '../App.css';
// import "./IndustrialEngineering.css"; // Optional external CSS if needed
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const IndustrialEngineering = () => {
  return (
    <div className="sector-detail">
      <Navbar />
      <header className="industrial-hero">
        <h1>Industrial Engineering</h1>
        <p>
        We provide advanced industrial engineering solutions to optimize processes, enhance
productivity and ensure operational efficiency across diverse sectors. Our experienced
team delivers innovative, cost-effective and sustainable engineering services tailored to
your needs.
</p>
      </header>
      <div className="sector-content">
        <h3 className="offer-title">What We Offer:</h3>
        <p>Our goal is to drive industrial excellence by delivering integrated Engineering Services and smart solutions that improve overall System Performance and reduce downtime.</p>
        <ul className="offer-list">
          <li>
            <span className="offer-icon"></span>
            Plant design and system optimization
          </li>
          <li>
            <span className="offer-icon"></span>
            Mechanical and Electrical system installations
          </li>
          <li>
            <span className="offer-icon"></span>
            Preventive maintenance and troubleshooting
          </li>
          <li>
            <span className="offer-icon"></span>
            Fabrication of industrial components
          </li>
          <li>
            <span className="offer-icon"></span>
            Process improvement and automation solutions
          </li>
          <li>
            Facility Management
          </li>
        </ul>
      </div>
      <LiveChat />
      <QAChatbot/>
      <ScrollSocialIcons/>
      <GetQuoteButton/>
      <BackToTopButton/>
      <Footer />
    </div>
  );
};

export default IndustrialEngineering;
